import { __export } from './chunk-7P6ASYW6.mjs';

// constants/pagination.ts
var pagination_exports = {};
__export(pagination_exports, {
  DEFAULT_PAGE_SIZE: () => DEFAULT_PAGE_SIZE
});
var DEFAULT_PAGE_SIZE = 25;

export { DEFAULT_PAGE_SIZE, pagination_exports };
